export default "__VITE_ASSET__Dfmm2VUD__"